import { createContext } from 'react';
export const Context = createContext({
  remove: () => {},
  set: () => {},
  handleClick: () => {},
  open: () => {},
  isRefRegistered: () => false
});